import Vue from "vue"
import VueChatScroll from 'vue-chat-scroll';
import ScrollDiv from 'vue-scroll-div';

Vue.use(ScrollDiv);
Vue.use(VueChatScroll);